import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Navigate  } from 'react-router-dom';



export default class Logout extends Component {
	 constructor(props) {
    super(props);
	 this.state = {redirect:false,pagename:''}
	 }
	componentDidMount() {
		var strusername="",strpawd="";
		
		localStorage.clear();
		
		this.setState({
							redirect: true,
							pagename:'/Userlogin'
						  }) 
	}
	render() {
		if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return (
<React.Fragment>
</React.Fragment>
)
	}
}



